export const START_MODE_TEMPLATE = 'template' as const
export const START_MODE_SCRATCH = 'scratch' as const

export type StartMode = typeof START_MODE_TEMPLATE | typeof START_MODE_SCRATCH

export const WIZARD_STEP = {
    START: 0,
    TEMPLATE: 1,
    CUSTOMIZE: 2
} as const

export type WizardStep = typeof WIZARD_STEP[keyof typeof WIZARD_STEP]

export const PROMPT_MIN_LENGTH = 10
